import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';

import { SnIconModule } from '@lib/ui/icon';

import { ChipsAutocompleteFormFieldComponent } from './components/form-field/chips-autocomplete-form-field.component';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    ReactiveFormsModule,
    // Material
    MatChipsModule,
    MatInputModule,
    MatAutocompleteModule,
    // Formly
    FormlySelectModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'chips-autocomplete',
          component: ChipsAutocompleteFormFieldComponent,
          wrappers: ['form-field'],
        },
      ],
    }),
    // Libs
    SnIconModule,
  ],
  declarations: [ChipsAutocompleteFormFieldComponent],
})
export class SnFormChipsAutocompleteModule {}
